var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isPc),expression:"!isPc"}],staticClass:"phone_header"},[_vm._v("苏州 市机动车排放阶段审核认定")]),_c('header',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPc),expression:"isPc"}],staticClass:"pc_header"}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }